module.exports = __webpack_public_path__ + "ab7f480750f966d55f30ac5931578900.jpg";